<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn
                    class="mr-1"
                    small
                    color="primary"
                    dark v-on="{...tooltip, ...dialog}"
                    v-on:click="()=>dialog=!dialog"
                >
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('kiosks.cardsCountInHoppers')}}</span>
        </v-tooltip>
        <DragForm
            v-model="dialog"
            @close="$emit('close')"
        >
            <v-card width="500">
                <v-card-title>
                    <span class="headline">{{$t('kiosks.cardsCountInHoppers')}}</span>
                </v-card-title>
                <v-card-text style="overflow-y: auto;  max-height: 800px">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.banks.Name')}} : {{device.bankName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.branches.Name')}} : {{device.branchName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.devices.Name')}} : {{device.deviceName}}
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                {{$t('referenceBooks.devices.DeviceTypeName')}} : {{device.kioskName}}
                            </v-col>

                        </v-row>
                    </v-container>
                    <ManageDeviceCardsList
                            :device="device"
                            :hoppersCount="hoppersCount"
                            @changed="(i, items) => selectedProducts[i-1] = items"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import ManageDeviceCardsList from '@/components/Kiosks/ManageDeviceCardsList';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
        
export default {
  name: 'CardsPerHopperForm',
  components: {DragForm, ManageDeviceCardsList},
  props: {
    device: {
      type: Object,
      required: true
    },
    hoppersCount: {
      type: Number,
      required: true
    },
    deviceId: {
      type: Number,
    }
  },
  data() {
    return {
      actionPerformed: false,
      success: false,
      error: false,
      products: [],
      dialog: false,
      selectedProducts: []
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getProducts();
      }
    }
  },
  methods: {
    clearData(){
      this.actionPerformed = false,
      this.success = false,
      this.error = false;
      this.products = [],
      this.selectedProducts = [];
    },
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    async save() {
      await this.$axios
        .products.attachProductsToDevice(
          this.device.deviceId,
          this.selectedProducts
            .map((array, index) => ({hopper: index + 1, productsId: array.map(p => p.productId)}))
            .filter(x => x.productsId.length)
        )
        .then(response => {
          notifySuccess('', this.$t('Messages.ProductsWereAttachedToDevice', [this.device.deviceName]));
          this.$emit('attach', response.status, this.device.deviceId);
        })
        .catch(error => {
          notifyError('', this.$t('Error'));
          console.error(error);
          this.$emit('error', error);
        });
    },
    async getProducts() {

      await this.$axios.products.getAvailableForDevice(this.device.deviceId)
        .then(response => response.data)
        .then(json => this.products = json)
        .catch(error => console.error(error));

    },
  },
  async mounted() {
    await this.getProducts();
  }

};
</script>